//! DO NOT EDIT THIS FILE IT IS GENERATED USING:
// mgs generate-flags

// Description: Allows us to quickly disable and re-enable the booking buttons for consultations
// Default On Variation: true
// Default Off Variation: false
export const FF_DISABLE_CONSULTATION_BUTTONS = 'disable_consultation_buttons';

// Description: feature flag to display discount code input that will be pass through the pre-screening -> payments flow
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_DISCOUNT_CODE = 'enable_discount_code';

// Description: When active a users medicare number will be validated
// Default On Variation: true
// Default Off Variation: false
export const FF_MEDICARE_CHECKSUM = 'medicare_checksum';

// Description: Enable/disable Google Places API in the address input.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_GOOGLE_PLACES = 'enable_google_places';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_EWAY_3DSECURE = 'enable_eway_3dsecure';

// Description: To allow testing with the various tokens for various scenarios
// Default On Variation: true
// Default Off Variation: false
export const FF_PPP_TESTING = 'ppp_testing';

// Description: Enables Snowplow Tracking
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SNOWPLOW = 'enable_snowplow';

// Description: When variant the payment page will be skipped in the prescreening flow, when control the payment info will be collected from patient,
// and when off the experiment is off and payment info will be collected from patient
// Default On Variation: control
// Default Off Variation: off
export const FF_PAYMENT_SKIPPED_FLOW_EXPERIMENT = 'payment_skipped_flow_experiment';

// Description: A feature used when testing various forms. This is only ever intended to be used for local / staging testing and should not be
// implemented on production
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_FORM_QUICK_SUBMIT = 'enable_form_quick_submit';

// Default On Variation: true
// Default Off Variation: false
export const FF_NURSE_INITIAL_CALL = 'nurse-initial-call';

// Description: Flag for managing immediate nurse consult release
// Default On Variation: true
// Default Off Variation: false
export const FF_IMMEDIATE_NURSE_CONSULTATION = 'immediate_nurse_consultation';

// Description: This flag enables single anonymous users rather than share-anonymous users to allow for % based rollouts in forms
// Default On Variation: true
// Default Off Variation: false
export const FF_ANONYMOUS_USERS = 'anonymous_users';

// Default On Variation: true
// Default Off Variation: false
export const FF_IMMEDIATE_NURSE_CONSULT_PERCENTAGE_GATE = 'immediate_nurse_consult_percentage_gate';

// Description: This flag will instruct the FE to show various experiences
// Default On Variation: variant
// Default Off Variation: control
export const FF_IMMEDIATE_NURSE_CONSULTATION_VARIANTS = 'immediate_nurse_consultation_variants';

// Description: Enable discount code validation using the newer PMS endpoint that uses Shopify to validate the codes.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SHOPIFY_DISCOUNT_VALIDATION = 'enable_shopify_discount_validation';

// Description: Pass along timezone based on presconsult dob selection
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_TIMEZONE_WITH_PRECONSULT_DOB = 'enable_timezone_with_preconsult_dob';

// Description: https://montugroup.atlassian.net/wiki/spaces/Eng/pages/957743166/SPIKE+Variable+Consult+Types+Calcom+Decouple
// Default On Variation: true
// Default Off Variation: false
export const FF_VARIABLE_CONSULT_TYPES_ENABLED = 'variable_consult_types_enabled';

// Description: Close calcom iFrames on successful bookings to prevent navigation rebooking issues
// Default On Variation: true
// Default Off Variation: false
export const FF_CLOSE_CALCOM_IFRAME_ON_SUCCESS = 'close_calcom_iframe_on_success';

// Description: https://montugroup.atlassian.net/browse/LGA-330
// Default On Variation: true
// Default Off Variation: false
export const FF_DOCTORS_ROUND_ROBIN_FOR_UNDER_25 = 'doctors_round_robin_for_under_25';

// Description: This feature flag will switch the UI from the legacy prescreening form to the new form builder version.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PRESCREENING_FORMBUILDER = 'enable_prescreening_formbuilder';

// Description: for auto-applying a campaign promo code via URL search params. Does not control discount logic, campaign selection, or validation.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_AUTO_PROMOTION_CODE = 'enable_auto_promotion_code';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_IMMEDIATE_CONSULTS_PROMO_CODES = 'enable_immediate_consults_promo_codes';

// Description: Notification for chat A/B testing
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_CHAT_NOTIFICATION_EXPERIMENT = 'c4c_chat_notification_experiment';

// Description: https://montugroup.atlassian.net/browse/LGA-724
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_INC_VIDEO_CALL = 'enable_inc_video_call';

// Description: Allows INC patients to use the chat functionality during a video consultation
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_INC_VIDEO_CHAT = 'c4c_inc_video_chat';

// Description: https://montugroup.atlassian.net/browse/PTJ-1309
// Default On Variation: true
// Default Off Variation: false
export const FF_MEDICAL_RECORDS_CONSENT_PAGE_V2 = 'medical_records_consent_page_v2';

// Description: Flag for managing immediate d2d consultation
// Default On Variation: true
// Default Off Variation: false
export const FF_IMMEDIATE_D2D_CONSULTATION = 'immediate_d2d_consultation';

// Description: Percentage rollout deciding whether a D2D-eligible patient is routed to the doctor flow or kept on the nurse flow.
// Default On Variation: true
// Default Off Variation: false
export const FF_ROUTE_PRESCREENING_PATIENT_TO_D2D = 'route_prescreening_patient_to_d2d';
